import React from 'react'
import { useSetAtom } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Box, Button } from '@node-space/ui-components'
import { ContactsSearch } from 'components/Contacts/ContactsSearch'
import { ContactAtomType } from 'types/atoms/atom.contacts'
import { ContactInstrumentDecisionStep } from 'types/contacts'
import { contactInstrumentDecisionStepAtom } from './atoms/contactAtoms'

interface ContactDecisionProps {
  setIsExistingContact: React.Dispatch<React.SetStateAction<boolean>>
}

export const ContactDecision = ({ setIsExistingContact }: ContactDecisionProps) => {
  const { t } = useTranslation()
  const setContactInstrumentDecisionStep = useSetAtom(contactInstrumentDecisionStepAtom)

  const handleAddContact = () => {
    setIsExistingContact(false)
    setContactInstrumentDecisionStep(ContactInstrumentDecisionStep.CONTACT)
  }

  return (
    <Box width="full">
      <ContactsSearch 
        showAddContact={false} 
        atomType={ContactAtomType.CONTACT_INSTRUMENT_ACTION}
      />
      <Box width="full" flex justify="center" paddingT={24}>
        <Button onClick={handleAddContact} full>
          {t('contacts.addANewContact')}
        </Button>
      </Box>
    </Box>
  )
}
